<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <template>
                        <section>
                            <b-field grouped>
                            <b-field label="Auth. Group">
                                <b-select placeholder="Select a Auth." v-model="authGroupSelected">
                                    <option
                                            v-for="authGroup in authGroups"
                                            :value="authGroup.id"
                                            :key="authGroup.id">
                                        {{ authGroup.name }}
                                    </option>
                                </b-select>
                            </b-field>
                            <b-field label="Update">
                                <b-button type="is-success" outlined  :disabled="!authGroupSelected" @click="updateAuthGroupGrant">Update</b-button>
                            </b-field>
                            </b-field>
                            <b-table
                                    :data="isEmpty ? [] : authGrants"
                                    bordered
                                    striped
                                    narrowed
                                    hoverable
                                    focusable
                            >



                                    <b-table-column  label="Name" v-slot="props">
                                        {{ props.row.name }}
                                    </b-table-column>
                                    <b-table-column  label="#"  v-slot="props">
                                        <b-switch v-model=" props.row.grant">
                                        </b-switch>
                                        {{ props.row.grant }}
                                    </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                        icon="emoticon-sad"
                                                        size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>


                        </section>
                    </template>
                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close"  @click="closeBtn">
                        Close
                    </b-button>
                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import { mapState } from "vuex";
    
    
    export default {
        name: "AuthGrant",
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            })
        },
        methods:{
            updateAuthGroupGrant(){
                    this.isFullScreenLoading = true
                    const  vm = this
                    var tmpArr = []
                    for(var i =0;i<this.authGrants.length;i++){
                       if(this.authGrants[i]['grant']){
                         // console.log(  this.authGrants[i]['id'] )
                           tmpArr.push(this.authGrants[i]['id'] )
                       }
                    }

                    const  datTo = {
                        "idauthgrp" : this.authGroupSelected,
                        "idauthgrant" : tmpArr
                    }
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/updateauthgrantbyauthgroup`,datTo,getConfigAxios())
                        .then(()=>{
                            vm.$buefy.toast.open({
                                message: 'Update Complete',
                                type: 'is-success'
                            })
                        })
                        .finally(()=>{
                            vm.isFullScreenLoading = false
                        })
            },
            closeBtn(){
              this.isComponentModalActive = false
            }
        },
        data(){
            return {
                isComponentModalActive : false,
                isFullScreenLoading : false,
                authGroups : [],
                authGrants : [],
                authGroupSelected : null,
                isEmpty : false
            }
        },
        watch:{
            isComponentModalActive : function (val) {
                if(val){
                    this.isFullScreenLoading = true
                    const  vm = this
                    const  datTo = {
                        "all" : false
                    }
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/listofauthgroup`,datTo,getConfigAxios())
                        .then((res)=>{
                            vm.authGroups = res.data
                        })
                        .finally(()=>{
                            vm.isFullScreenLoading = false
                        })
                }
            },

            authGroupSelected : function (val) {
                if(val){
                    this.isFullScreenLoading = true
                    const  vm = this
                    const  datTo = {
                        "idauthgrp" : val
                    }
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/listofauthgrantbyauthgroup`,datTo,getConfigAxios())
                        .then((res)=>{
                            vm.authGrants = res.data
                        })
                        .finally(()=>{
                            vm.isFullScreenLoading = false
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>